<template>
	<div class="container">
		<div class="panel">
			<div class="center-tabs">
				<div :class="['tab-item',{active:curr_tab == 'personal'}]" @click="curr_tab='personal'">个人资料</div>
				<div v-if="userInfo.designer_level_id>0" :class="['tab-item',{active:curr_tab == 'designer'}]" @click="curr_tab='designer'">设计师简介</div>
			</div>
			<!-- <h2>个人资料</h2> -->
			<div class="form" v-if="curr_tab=='personal'">
				<div class="form-group">
					<div class="form-label">用户名：</div>
					<div class="form-control">
						<input type="text" class="input" readonly v-model="form_data1.username" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">注册日期：</div>
					<div class="form-control">
						<input type="text" class="input" readonly v-model="form_data1.create_time" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">手机号码：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请填写手机号码" v-model="form_data1.mobile" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">昵称：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请填写昵称" v-model="form_data1.nickname" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">真实姓名：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请填写真实姓名" v-model="form_data1.realname" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">性别：</div>
					<div class="form-control">
						<div class="sex-wrap">
							<div class="sex-item" :class="{active:form_data1.sex===1}" @click="choose_sex(1)">男<img v-if="form_data1.sex===1" src="../../assets/images/icon-selected2.png" class="selected" /></div>
							<div class="sex-item" :class="{active:form_data1.sex===2}" @click="choose_sex(2)">女<img v-if="form_data1.sex===2" src="../../assets/images/icon-selected2.png" class="selected" /></div>
						</div>
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">出生日期：</div>
					<div class="form-control">
						<input type="date" class="input" placeholder="请确认新密码" v-model="form_data1.birthday" />
					</div>
				</div>
				<div class="form-group" >
					<div class="form-label">所在地区：</div>
					<div class="form-control">
						<Cascader class="input1" :data="region" v-model="value"  placeholder="请选择省/市/区/街道"></Cascader>
					</div>
				</div>

				<div class=avatar-wrap>
					<img class="avatar" :src="form_data1.avatar|default_img" alt="">
					<Upload :action="upload_url"
							:data="{dir:'template'}"
							:show-upload-list="false"
							:on-success="handleSuccess"
					>
						<div class="btn-avatar">上传头像</div>
					</Upload>
				</div>

				<div class="btn-submit" @click="save1">保存</div>
			</div>
		</div>

		<div class="panel" v-if="curr_tab=='personal'">
			<h2>修改密码</h2>
			<div class="form">
				<div class="form-group">
					<div class="form-label">新密码：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请输入新密码" v-model="form_data2.password" />
					</div>
				</div>
				<div class="form-group">
					<div class="form-label">确认新密码：</div>
					<div class="form-control">
						<input type="text" class="input" placeholder="请确认新密码" v-model="form_data2.confirm_password" />
					</div>
				</div>

				<div class="btn-submit" @click="save2">保存</div>
			</div>
		</div>
		<div class="panel" v-if="curr_tab=='personal'">
			<h2>银行账户</h2>
			<div class="form">
				<div class="bank-edit-wrapper">
					<div class="form-group">
						<div class="form-label">账户类型：</div>
						<div class="form-control">
							<RadioGroup v-model="form_bank.card_type">
								<Radio :label="1">对私</Radio>
								<Radio :label="2">对公</Radio>
                            </RadioGroup>
						</div>
					</div>
					
					<div class="form-group">
						<div class="form-label">开户行：</div>
						<div class="form-control">
							 <Select v-model="form_bank.card_code" filterable @on-change="changeBank" label-in-value>
								<Option v-for="item in banckList" :value="item.bank_code" :key="item.bank_code">{{ item.bank_name }}</Option>
							</Select>
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">开户地址：</div>
						<div class="form-control">
							<Cascader class="input1" filterable :data="backArea" v-model="form_bank.bank_area"   placeholder="请选择开户地址"></Cascader>
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">开户支行：</div>
						<div class="form-control">
							<Select v-model="form_bank.branch_code" filterable @on-change="changeBranch" label-in-value>
								<Option v-for="item in branchList" :value="item.branch_code" :key="item.branch_code">{{ item.branch_name }}</Option>
							</Select>
							
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">开户名称：</div>
						<div class="form-control">
							<Input v-model="form_bank.card_name" placeholder="请输入持卡人姓名/对公账户名称" clearable />
						</div>
					</div>
					<div class="form-group">
						<div class="form-label">银行卡号：</div>
						<div class="form-control">
							<Input v-model="form_bank.card_no" type="number" placeholder="请输入银行卡号" clearable />
						</div>
					</div>
					
					
					<div class="form-group">
						<div class="form-label">手机号码：</div>
						<div class="form-control">
							<Input v-model="form_bank.card_mobile" placeholder="请输入银行预留手机号码" clearable />
						</div>
					</div>
                    <!-- <div class="form-group">
						<div class="form-label">地址：</div>
						<div class="form-control">
							<Input v-model="form_bank.address" placeholder="请输入地址" clearable />
						</div>
					</div> -->
                    
                </div>

				<div class="btn-submit" @click="saveBank">保存</div>
			</div>
		</div>
		<div v-if="curr_tab === 'designer'" class="designer-form">
			<div class="top-form">
				<div class="designer-pic">
					<img :src="form_designer.designer_pic || require('@/assets/images/user-center/bg-default-designer-pic.png')" alt="" />
					<Upload
						action="/"
						:before-upload="(file)=>onBeforeUpload(file)"
						:format="['jpg', 'jpeg', 'png', 'gif','webp']"
						accept=".jpg,.jpeg,.png,.gif,.webp"
					>
						<div class="upload-btn">
							<img src="../../assets/images/user-center/icon-upload-designer-pic.png" alt="" class="btn-icon" />上传自己的形象照
						</div>
					</Upload>
				</div>
				<div class="basic-form">
					<div class="basic-title">
						<div class="title">编辑个人简介</div>
						<div class="desc">完善的简介有助于获得更多关注</div>
					</div>
					<div class="form-2-col">
						<div class="basic-form-group">
							<div class="form-label required">设计师姓名</div>
							<Input placeholder="请输入设计师姓名" v-model="form_designer.designer_name"></Input>
						</div>
						<div class="basic-form-group">
							<div class="form-label required">设计师头衔</div>
							<Input placeholder="请输入设计师头衔" v-model="form_designer.designer_title"></Input>
						</div>
					</div>
					<div class="form-1-col">
						<div class="basic-form-group">
							<div class="form-label required">擅长风格 <div class="label-tips">(可多选)</div></div>
							<Select multiple placeholder="请选择擅长风格" v-model="form_designer.designer_styles">
								<Option v-for="(item,index) in setting.styles" :key="`opt-index-${index}`" :label="item.title" :value="item.title"></Option>
								<!-- <Option label="风格2" value="风格2"></Option>
								<Option label="风格3" value="风格3"></Option>
								<Option label="风格4" value="风格4"></Option>
								<Option label="风格5" value="风格5"></Option> -->
							</Select>
						</div>
					</div>
					<div class="form-1-col">
						<div class="basic-form-group">
							<div class="form-label required">个人简介</div>
							<textarea placeholder="请输入个人简介" :rows="4" v-model="form_designer.designer_introduction" />
						</div>
					</div>
				</div>
			</div>
			<div class="other-form">
				<div class="label">其它简介及荣誉 <span class="label-tips">(支持自由编辑 可上传图片/视频)</span> </div>
				<Editor dir="user" v-model="form_designer.designer_hornor" @change="onChangeRichText"></Editor>
			</div>
			<div class="btn-box">
				<div class="btn-item reset" @click="form_designer={}">重置</div>
				<div class="btn-item confirm" @click="onSaveDeisgnerInfo">确认保存</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
	GetBankArea,
	GetBankList,
	GetBranchList,
	GetUserBank,
	Profile,
	RevisePassword,
	SaveProfile,
	SaveUserBank,
} from "@/api/index.js";
import Editor from '@/components/WangEditor';
import { uploadFileToOSS } from "@/utils/oss";
import region from "@/utils/region.js";
import { mapState } from 'vuex';

	export default {
		name: 'UserCenter',
		components: {
			Editor
		},
		data() {
			return {
				upload_url: process.uniEnv.BASE_API + '/util/upload-image',
				value: [],
				region: region,
				form_data1: {
					username: '',
					mobile: '',
					nickname:'',
					realname: '',
					sex: 0,
					birthday: '',
					province: '',
					city: '',
					zone: '',
					create_time: ''
				},
				form_data2: {
					password: '',
					confirm_password: '',
				},
				curr_tab:'personal',
				form_designer:{
					designer_pic:""
				},
				form_bank:{
					card_type:1,
					card_name:'',
					card_no:'',
					card_bank:'',
					card_branch:'',
					card_mobile:'',
					address:'',
					branch_code:'',
					card_code:'',
					bank_area:[]
				},
				banckList:[],
				branchList:[],
				backArea:[]
			};
		},
		computed:{
			...mapState({
				userInfo:(state)=>state.userInfo,
				setting:(state)=>state.setting
			})
		},
		mounted() {
			// axios.all([
			// 	this.getProfile(),
			// ]).then(axios.spread((response1) => {

			// }))
			Promise.all([
				this.getProfile(),
				this.getUserBank(),
				this.getBankList(),
				this.getBankArea()

				// this.onGetProductCateList()
			])
		},
		watch:{
        	'form_bank.bank_area'(news,olds){
				console.log(news)
            	this.geBranchList()
        	},
			
    	},
		methods: {
			async getBankList() {
				let { data } = await GetBankList()
				this.banckList = data
			},
			async getBankArea() {
				let { data } = await GetBankArea()
				this.backArea = data
			},
			
			changeBank(e){
				this.form_bank.card_bank = e.label
				this.geBranchList()
			},
			
			async geBranchList(){
				let param = {
					bank_code:this.form_bank.card_code,
				}
				if(this.form_bank.bank_area){
					param.area_code = this.form_bank.bank_area[1]
				}
				let { data } = await GetBranchList(param)
				this.branchList = data
			},
			changeBranch(e){
				if(e){
					this.form_bank.card_branch = e.label
				}
			},
			async getUserBank(){
				let { data } = await GetUserBank()
				if(data){
					this.form_bank = data
				}
			},
			async saveBank() {
				console.log(this.form_bank)
				 if (!this.form_bank.card_name.trim()) {
					return this.$layer.msg('请输入开户名')
				}
				if (!this.form_bank.card_no.trim()) {
					return this.$layer.msg('请输入银行卡号')
				}
				if (!/^\d{16,19}$/.test(this.form_bank.card_no.replace(/\s/g, ''))) {
					return this.$layer.msg('请输入正确的银行卡号')
				}
				if (!this.form_bank.card_mobile.trim()) {
					return this.$layer.msg('请输入手机号码')
				}
				if (!/^1[3-9]\d{9}$/.test(this.form_bank.card_mobile)) {
					return this.$layer.msg('请输入正确的手机号码')
				}
				if (!this.form_bank.card_bank) {
					return this.$layer.msg('请选择开户行')
				}
				if (this.form_bank.bank_area.length == 0) {
					return this.$layer.msg('请选择开户地址')
				}
				if (!this.form_bank.card_branch) {
					return this.$layer.msg('请选择开户支行')
				}
				let { data,code } = await SaveUserBank(this.form_bank)
				this.$layer.msg(`保存成功`)
			},
			onChangeRichText(e){
				// console.log('e-rich',e);
				this.form_designer.designer_hornor = e;
				// console.log('this.form_designer',this.form_designer.designer_hornor);
			},
			onSaveDeisgnerInfo(){
				// console.log('designer_form',this.form_designer);
				SaveProfile(this.form_designer).then(res=>{
					this.$layer.msg('保存成功~');
					this.getProfile();
				}).catch(({code,msg})=>{
					console.log('code',code,'msg',msg);
					this.$layer.msg(msg)
				})
			},
			onBeforeUpload(file){
				console.log('file',file);
				uploadFileToOSS(file,'template').then(url=>{
					this.$set(this.form_designer,'designer_pic',url);
				})
				return false;
			},
			handleSuccess(response, file, fileList) {
				this.form_data1.avatar = response.data.url
			},
			choose_sex(sex) {
				this.form_data1.sex = sex
			},
			save1() {
				this.form_data1.province = this.value[0]
				this.form_data1.city = this.value[1]
				this.form_data1.zone = this.value[2]
				SaveProfile(this.form_data1).then(() => {
					this.$layer.msg(`保存成功`)
				}).finally(()=> {
					this.getProfile()
				})
			},
			save2() {
				if(!this.form_data2.password) {
					this.$layer.msg("请输入密码")
					return
				}
				if(!this.form_data2.confirm_password) {
					this.$layer.msg("请输入确认密码")
					return
				}
				if(this.form_data2.password != this.form_data2.confirm_password) {
					this.$layer.msg("两次密码不一致")
					return
				}
				RevisePassword(this.form_data2).then(() => {
					this.$layer.msg(`保存成功`)
				}).finally(()=> {
					this.getProfile()
					this.form_data2.password = this.form_data2.confirm_password = ''
				})
			},
			async getProfile() {
				return Profile().then(response => {
					this.$store.commit('setUserInfo', this.$_.cloneDeep(response.data))
					this.form_data1 = response.data
					this.value = [this.form_data1.province, this.form_data1.city, this.form_data1.zone]
					const {designer_hornor,designer_introduction,designer_name,designer_pic,designer_title,designer_styles} = response.data;
					this.form_designer = {designer_hornor,designer_introduction,designer_name,designer_pic,designer_title,designer_styles};
					return response
				})
			},
		},

	}
</script>

<style lang="scss" scoped>
	.container {
		padding-bottom:180px;
		.panel {
			// margin-bottom: 10px;
			padding: 8px 30px 17px 30px;
			background: white;
			h2 {
				color: #333333;
				padding: 24px 0;
				border-bottom: 1px solid #EBEBEB;
				font-size: 18px;
				font-weight: bold;
			}
			.center-tabs{
				width:100%;
				padding-top:24px;
				padding-bottom:15px;
				border-bottom:1px solid #d6d6d6;
				display:flex;
				align-items:center;
				column-gap:48px;
				.tab-item{
					color:#666;
					font-size:16px;
					cursor:pointer;
					&.active{
						color:#1a1a1a;
						font-size:18px;
						font-weight:bold;
						position:relative;
						&::after{
							content:"";
							width:100%;
							height:3px;
							background:#ff5967;
							position:absolute;
							left:0;
							bottom:-15px;
						}
					}
				}
			}
			.form {
				position: relative;
				padding: 10px 0;
				.form-group {
					display: flex;
					flex-wrap: wrap;
					justify-content: left;
					align-items: center;
					margin-top: 20px;
					.form-label {
						width: 100px;
						font-size: 14px;
						color: #696A6A;
						text-align: right;
					}
					.form-control {
						position: relative;
						.input {
							width: 300px;
							height: 48px;
							line-height: 48px;
							border: 1px solid #E3E3E3;
							border-radius: 10px;
							padding: 0 10px;
							outline: none;
							&[readonly] {
								border: none;
							}
						}

						.sex-wrap {
							display: flex;
							flex-wrap: nowrap;
							.sex-item {
								position: relative;
								width: 145px;
								height: 40px;
								line-height: 40px;
								text-align: center;
								border: 1px solid #E3E3E3;
								border-radius: 10px;
								margin: 0 5px;
								cursor: pointer;
								color: #363235;
								&.active {
									color: #FA3D5A;
									border-color: #FA3D5A;
								}
								.selected {
									position: absolute;
									bottom: 0;
									right: 0;
									width: 22px;
									height: 22px;
								}
							}
						}
					}


				}
				.avatar-wrap {
					position: absolute;
					top: 32px;
					right: 150px;
					.avatar {
						width: 120px;
						height: 120px;
						border-radius: 50%;
					}
					.btn-avatar {
						margin-top: 20px;
						width: 110px;
						height: 40px;
						line-height: 40px;
						background: #EDEFF2;
						border-radius: 10px 10px 10px 10px;
						font-size: 14px;
						color: #363235;
						text-align: center;
						cursor: pointer;
					}
				}
				.btn-submit {
					margin: 40px 0 0 40px;
					width: 110px;
					height: 40px;
					line-height: 40px;
					text-align: center;
					background: #FA3D5A;
					color: white;
					border-radius: 6px;
					cursor: pointer;
				}

			}
		}
		.designer-form{
			display:flex;
			flex-direction:column;
			row-gap:33px;
			width:100%;
			max-width:1100px;
			padding: 8px 30px 17px 30px;
			background:#fff;
			.top-form{
				display:flex;
				column-gap:32px;
				width:100%;
				.designer-pic{
					width:300px;
					height:377px;
					border:1px solid #e3e3e3;
					border-radius:8px;
					overflow:hidden;
					position:relative;
					img{
						width:100%;
						height:100%;
						border-radius:8px;
						object-fit:cover;
						object-position: center;
					}
					.upload-btn{
						position:absolute;
						bottom:24px;
						left:60px;
						width:180px;
						height:40px;
						background:rgba(0,0,0,0.6);
						color:#fff;
						font-size:14px;
						display:flex;
						align-items:center;
						justify-content: center;
						column-gap:8px;
						border-radius:8px;
						cursor:pointer;
						.btn-icon{
							width:24px;
							height:24px;
						}
					}
				}
				.basic-form{
					display:flex;
					flex-direction:column;
					flex:1;
					.basic-title{
						display:flex;
						align-items:center;
						justify-content:space-between;
						margin-bottom:24px;
						.title{
							color:#333;
							font-size:18px;
							font-weight:bold;
						}
						.desc{
							color:#999;
							font-size:14px;
						}
					}
					.form-2-col{
						display:flex;
						column-gap:17px;
						margin-bottom:16px;
					}
					.form-1-col{
						width:100%;
						margin-bottom:16px;
					}
					.basic-form-group{
						display:flex;
						flex-direction:column;
						row-gap:10px;
						flex:1;

						.form-label{
							color:#333;
							font-size:14px;
							display:flex;
							align-items:center;
							&.required::after{
								content:"*";
								color:red;
							}
							.label-tips{
								color:#666;
								font-size:12px;
							}
						}
						::v-deep .ivu-input{
							width:100%;
							height:50px;
						}

						::v-deep .ivu-select{
							width:100%;
							height:50px;
							.ivu-select-selection{
								height:100%;
								display:flex;
								align-items:center;
							}
						}

						textarea{
							width:100%;
							// height:98px;
							padding:5px 10px;
							border:1px solid #e3e3e3;
							border-radius:8px;
							outline:none;
						}
					}
				}
			}
			.other-form{
				width:100%;
				display:flex;
				flex-direction:column;
				.label{
					color:#333;
					font-size:14px;
					display:flex;
					align-items:center;
					margin-bottom:16px;
					.label-tips{
						color:#999;
						font-size:14px;
					}
				}
			}
			.btn-box{
				display:flex;
				align-items:center;
				justify-content:center;
				width:100%;
				margin-top:20px;
				column-gap:16px;
				.btn-item{
					width:120px;
					height:40px;
					border-radius:4px;
					line-height:40px;
					text-align:center;
					cursor:pointer;
					font-size:14px;
					&.reset{
						border:1px solid #e3e3e3;
						color:#666;
					}
					&.confirm{
						color:#fff;
						background:#ff5967;
					}
				}
			}
		}
	}

	::v-deep .ivu-input {
		width: 300px;
		height: 48px;
		line-height: 48px;
		border: 1px solid #E3E3E3;
		border-radius: 10px;
		padding: 0 10px;
		outline: none;
	}
	
	::v-deep .ivu-select {
		width: 300px;
	}
	.bank-edit-wrapper{
            width:100%;
            display:flex;
            flex-direction:column;
            .bank-edit-title-desc{
                width:100%;
                display:flex;
                flex-direction:column;
                row-gap:6px;
                margin-top:32px;
                .title{
                    color:#333;
                    font-weight:bold;
                    font-size:18px;
                }
                .desc{
                    color:#999;
                    font-size:14px;
                }
            }
            .form{
                display:flex;
                flex-direction:column;
                row-gap:32px;
                margin-top:32px;
                .form-item{
                    display:flex;
                    align-items:center;
                    column-gap:16px;
                    .item-label{
                        color:#333;
                        font-size:14px;
                        width:63px;
                        &.required::after{
                            content:"*";
                            color:red;
                        }
                    }
                    .item-value{
                        width:100%;
                        max-width:679px;
                    }
                }
            }
        }
</style>
